import gettersMethods from './getters';
import mutationsMethods from './mutations';
import actionsMethods from './actions';

export default {
   namespaced : true,

   state() {
      return {
         user: null,
         auth: getCookie(JWT_COOKIE_NAME) ? true : false,
      }
   },

   getters: gettersMethods,
   mutations: mutationsMethods,
   actions: actionsMethods
};